import apiService from '../../../services/api'
import { CRASH_API } from '../config/crashConfig'

/**
 * Crash REST API
 *
 * В реальном времени игра идёт целиком по сокету (см. crashSocket.js).
 * REST нужен только для:
 *  - первой отрисовки экрана ставки (GET /api/crash/inventory/) — пока поднимается сокет;
 *  - экрана истории: общая, личная, просмотр одного раунда (§9a).
 *
 * Авторизация — обычная, как во всех остальных запросах (через apiService.makeRequest).
 */

export const crashApi = {
  /**
   * Получить баланс, инвентарь для ставки и лимиты.
   * GET /api/crash/inventory/
   *
   * Опрашивать в цикле НЕ надо — дальше и баланс, и инвентарь приезжают по сокету
   * (user:balance, crash:inventory либо user:inventory как сигнал обновить REST).
   */
  getInventory: async (signal, skipBalanceSync = false) => {
    try {
      return await apiService.makeRequest(CRASH_API.INVENTORY, {
        method: 'GET',
        signal,
        skipBalanceSync
      })
    } catch (error) {
      console.error('Ошибка получения инвентаря Crash:', error)
      throw error
    }
  },

  /**
   * История всех раундов (общая).
   * GET /api/crash/history/?before=<cursor>
   * @param {string|null} before — курсор следующей страницы (next_before), null = первая
   */
  getHistory: async (before = null, signal) => {
    const query = before ? `?before=${encodeURIComponent(before)}` : ''
    try {
      return await apiService.makeRequest(`${CRASH_API.HISTORY}${query}`, {
        method: 'GET',
        signal
      })
    } catch (error) {
      console.error('Ошибка получения истории Crash:', error)
      throw error
    }
  },

  /**
   * История своих раундов.
   * GET /api/crash/history/me/?before=<cursor>
   */
  getMyHistory: async (before = null, signal) => {
    const query = before ? `?before=${encodeURIComponent(before)}` : ''
    try {
      return await apiService.makeRequest(`${CRASH_API.HISTORY_ME}${query}`, {
        method: 'GET',
        signal
      })
    } catch (error) {
      console.error('Ошибка получения личной истории Crash:', error)
      throw error
    }
  },

  /**
   * Просмотр одного раунда со всеми ставками.
   * GET /api/crash/history/{uid}/
   *
   * 404 round not found — раунд не найден или ещё идёт (§9a).
   */
  getRound: async (uid, signal) => {
    try {
      return await apiService.makeRequest(CRASH_API.ROUND(uid), {
        method: 'GET',
        signal
      })
    } catch (error) {
      console.error('Ошибка получения раунда Crash по uid:', error)
      throw error
    }
  }
}

export default crashApi
